import ReactGA from 'react-ga4';

export default function PageTracking() {
    ReactGA.initialize('G-R06KL7CGBW', { gaOptions: { cookieFlags: "SameSite=None;Secure" } });
    
    return null;
}